import React from 'react';
import TipsPhotoBg from './TipsPhotoBg';
import historyImg from '../assets/tips/history/history1.jpg';
import TipsHeader from './TipsHeader';
import { dynasties } from '../data';
import History from './History';

const HistoryTips = () => {
  return (
    <section className="section">
      <div className="section-center">
        <div className="tips-container">
          <TipsPhotoBg img={historyImg} />

          <article className="article-container">
            <TipsHeader
              title="Vietnam is a country founded in legends. Millennia of invasions and conflicts have shaped Vietnamese culture into what you see today."
              author="Nam Nguyen"
              date="28 November 2021"
            />

            {dynasties.map((dynasty, index) => {
              return (
                <History
                  dynasty={dynasty}
                  key={dynasty.id}
                  visit={dynasties.length - 1 !== index}
                />
              );
            })}
          </article>
        </div>
      </div>
    </section>
  );
};

export default HistoryTips;
